<template>
  <div class="stripe-payment">
    <section style="position: relative">
      <div
        @click="scroll('left', 'plansWrapper')"
        class="arrow arrow__left arrow__subscription"
      >
        <v-icon>chevron_left</v-icon>
      </div>
      <div
        @click="scroll('right', 'plansWrapper')"
        class="arrow arrow__right arrow__subscription"
      >
        <v-icon>chevron_right</v-icon>
      </div>

      <h4 class="text-xs-left">Wähle zuerst ein passendes Match-Abo aus.</h4>

      <div
        ref="plansWrapper"
        class="scrolling-wrapper-flexbox"
        style="margin-right: 15px"
      >
        <button
          v-for="plan in plans"
          @click="selectedPlan = plan"
          :key="plan.id"
          :class="[
            'plan-button',
            { 'plan-button-active': selectedPlan.id === plan.id },
            { 'most-selected-plan': plan.mostSelected },
          ]"
        >
          <strong style="font-size: 16px; font-weight: 800">{{ plan.name }}</strong
          ><br />
          <span v-html="`unbegrenzt matchen<BR>${plan.price}`"></span>
          <div v-if="plan.mostSelected" class="most-selected">MEIST GEWÄHLT</div>
        </button>
        <!-- scroll buffor -->
        <div style="min-width: 1px"></div>
      </div>

      <div class="small_text">
        <small> *Abo verlängert sich automatisch. | Jederzeit kündbar. </small>
      </div>

      <div>
        <h4 class="text-xs-left mt-2">
          Gib hier die Daten des Rechnungsempfängers ein.
        </h4>
        <v-form v-model="userDataFormValid">
          <v-container>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.name"
                  :rules="nameRules"
                  label="Vor- und Nachname / Vereinsname / Firmenname"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.email"
                  :rules="emailRules"
                  label="E-Mail-Adresse"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.contactPerson"
                  :rules="contactPersonRules"
                  label="Ansprechpartner"
                  required
                  :disabled="false"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.address.line1"
                  :rules="line1Rules"
                  label="Straße, Hausnummer"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                  color="green"
                  v-model="form.address.postal_code"
                  :rules="postalcodeRules"
                  label="PLZ"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  color="green"
                  v-model="form.address.city"
                  :rules="cityRules"
                  label="Ort"
                  required
                  :disabled="formDisabled"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-autocomplete
                  color="green"
                  :items="this.$store.state.nationalities"
                  style="padding-top: 2px"
                  :rules="countryRules"
                  item-text="item_text"
                  item-value="id"
                  v-model="form.address.country"
                  required
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <div style="color: #aaaaaa; font-size: 12px">
              Die Rechnung kannst du unter Einstellungen/Abo-Übersicht downloaden.
            </div>
          </v-container>
        </v-form>
      </div>

      <div class="promo-section">
        <h4 class="text-xs-left mt-2">Du hast einen Rabattcode?</h4>
        <v-text-field
          color="green"
          v-model="promoCodeInput"
          label="Dann kannst du ihn hier eingeben und aktivieren."
        >
          <template v-slot:append-outer>
            <button @click="checkCode" class="promo-button">
              <v-icon color="white" v-if="promoCodeIcon">{{ promoCodeIcon }}</v-icon>
              <span v-else>Code aktivieren</span>
            </button>
          </template>
        </v-text-field>

        <div v-if="promoCode" class="promo-info">
          {{ promoCode.coupon.name }}
        </div>
      </div>

      <div>
        <h4 class="text-xs-left mt-2">
          Wähle abschließend die bevorzugte Zahlungsart aus.
        </h4>

        <div style="width: 90%; margin: 10px auto">
          <button :disabled="creatingStripeCustomer">
            <img
              v-for="(payment, index) in payments"
              @click="selectPayment(payment)"
              :key="`payment-${index}`"
              :src="require(`@/assets/icons/payments/${payment.icon}.png`)"
              width="70"
              height="50"
              style="margin-right: 4px"
              :class="{
                'payment-selected': payment.component === activeComponent,
                'payment-disabled': !userDataFormValid,
              }"
            />
            <!-- {{ payment }} -->
          </button>
        </div>
      </div>
    </section>

    <section v-if="activeComponent">
      <component
        :is="activeComponent"
        :customerData="customerData"
        :payButtonEnabled="!!selectedPlan.id && !!stripeCustomerId"
        :orderedItem="selectedPlan"
        :stripeCustomerId="stripeCustomerId"
        :latestSubscription="latestSubscription"
        :promoCode="promoCode"
        :billingData="form"
        @payment-successful="paymentSuccessful"
      />
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Axios from 'axios';
import { db } from '@/db';
import stripeMixin from '../../mixins/stripe';
import Card from '../../components/stripe/SubscribeByCard';
import Iban from '../../components/stripe/SubscribeByIban';
import Paypal from '../../components/paypal/Subscription';
import { cloudFunctionsBackoffice, subscriptions } from '../../config';
import stripeHelper from '../../mixins/stripe-helper';

export default {
  name: 'stripe-subscription',

  components: {
    Card,
    Iban,
    Paypal,
  },

  mixins: [stripeMixin, stripeHelper],

  data() {
    return {
      payments: [
        { component: 'Card', icon: 'mastercard' },
        { component: 'Iban', icon: 'banktransfer' },
        { component: 'Paypal', icon: 'paypal-alternative', active: true },
      ],
      plans: {},
      activeComponent: undefined,
      userDataFormValid: false,
      stripeCustomerId: null,
      creatingStripeCustomer: false,
      latestSubscription: null,
      form: {
        email: '',
        name: '',
        address: {
          city: '',
          line1: '',
          line2: '',
          postal_code: '',
          country: 'DE',
        },
      },
      formDisabled: false,
      emailRules: [
        (v) => !!v || 'E-mail ist Pflichtfeld',
        (v) => /.+@.+/.test(v) || 'E-mail ist invalid',
      ],
      nameRules: [(v) => !!v || 'Name ist Pflichtfeld'],
      contactPersonRules: [(v) => !!v || 'Ansprechpartner ist Pflichtfeld'],
      line1Rules: [(v) => !!v || 'Strasse/Hausnummer ist Pflichtfeld'],
      postalcodeRules: [(v) => !!v || 'PLZ ist Pflichtfeld'],
      cityRules: [(v) => !!v || 'Ort ist Pflichtfeld'],
      countryRules: [(v) => !!v || 'Land ist Pflichtfeld'],
      selectedPlan: {},
    };
  },

  computed: {
    ...mapState(['user_data', 'userType']),

    customerData() {
      return {
        email: this.form.email,
        name: this.form.name,
      };
    },

    userIsPlayerOrTrainer() {
      return this.userType === 'users' || this.userType === 'trainers';
    },
  },

  methods: {
    async selectPayment(payment) {
      if (payment.component === 'paypal') {
        this.activeComponent = payment.component;
        return;
      }

      if (!!this.selectedPlan.id && this.userDataFormValid) {
        this.creatingStripeCustomer = true;

        if (!this.stripeCustomerId) {
          this.$store.state.loading = true;
          const data = {
            ...this.form,
            accountId: this.user_data.id,
            accountType: this.userType,
          };

          const customerId = await this.createCustomer(data);
          this.stripeCustomerId = customerId;
          this.$store.state.loading = false;
        }

        this.activeComponent = payment.component;
        this.creatingStripeCustomer = false;
      } else {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Bitte alle Rechnungsdaten angeben.',
        });
      }
    },

    paymentSuccessful(payment) {
      const batch = db.batch();

      console.log('payment', payment);

      // update user swipes
      const refLoggedUser = db.collection(this.userType).doc(this.user_data.id);
      if (this.userIsPlayerOrTrainer) {
        batch.update(refLoggedUser, { swipesLeft: payment.paidPlan.swipes });
      }

      // save payment in firestore
      const newPaymentRef = db.collection('payments').doc();
      const paymentData = {
        stripe_payment_id: payment.paymentId ? payment.paymentId : '',
        paypal_order_id: payment.subscription
          ? payment.subscription.subscription.orderID
          : '',
        account_type: this.userType,
        account_id: this.user_data.id,
        plan_details: payment.paidPlan,
        timestamp: Date.now(),
      };
      batch.set(newPaymentRef, paymentData);

      if (payment.source === 'paypal-subscription') {
        if (payment.subscription.subscription.subscriptionID) {
          const results = { ...payment };
          const subscriptionId = payment.subscription.subscription.subscriptionID;
          const subscriptionData = {
            subscriptionId,
            isCanceled: false,
            subscriptionTimeInMonths: +payment.paidPlan.name.replace(' Monate', ''),
            subscriptionStart: moment().unix(),
          };
          batch.update(refLoggedUser, { subscriptionData });

          const subscriptionRef = db.collection('subscriptions').doc(subscriptionId);
          batch.set(subscriptionRef, results);
        }
      }

      // run batch
      batch
        .commit()
        .then(async () => {
          const data = {
            amount: Math.round(payment.paidPlan.value / 100).toFixed(2),
            email: this.user_data.email,
            affiliateId: this.user_data.affilliateID,
            ...paymentData,
          };

          await Axios({
            method: 'post',
            url: `${cloudFunctionsBackoffice}/newPayment`,
            headers: {
              'content-type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            data: JSON.stringify(data),
          });

          this.$store.commit({
            type: 'openSnackbar',
            text: 'Du kannst jetzt deine Swipes nutzen.',
          });
        })
        .catch((err) => {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Ups, da ist etwas schief gelaufen',
          });
          console.log({ err });
        });
    },

    clearCache() {
      localStorage.clear();
    },
  },

  created() {
    this.plans = subscriptions[this.userType];
    this.selectedPlan = this.plans.find((p) => p.mostSelected);
    this.form.email = this.user_data.email;
    this.form.name = this.user_data.name;

    if (this.user_data.stripe_customer) {
      const { stripe_customer_id, ...restWithoutCustomerId } =
        this.user_data.stripe_customer;

      this.stripeCustomerId = stripe_customer_id;
      this.form = {
        ...restWithoutCustomerId,
      };
      this.formDisabled = true;
    }

    // not finished subscription
    const lastSubscr = localStorage.getItem('latestSubscription');
    this.latestSubscription = lastSubscr ? JSON.parse(lastSubscr) : null;
  },

  mounted() {
    // scroll to the middle of plans div, to show selected plan in center
    this.$refs.plansWrapper.scrollLeft =
      (this.$refs.plansWrapper.scrollWidth - this.$refs.plansWrapper.clientWidth) / 2;
  },
};
</script>
